import React, { useMemo } from 'react';
import {
    parseReadinessResponse,
    readinessCardValues,
    parseCPUResponse,
    cpuCardValues,
    parseRAMResponse,
    ramCardValues,
    parseStorageResponse,
    storageCardValues,
} from '../Card/CardParsers';
import { CARD_TYPES } from '../Card/cardTypes';
import { SummaryCardRenderer, buildCards } from '../Card/SummaryCardRenderer';

export const InventoryCardsSection = ({ 
    summaryData, 
    totalInventory, 
    isExpanded, 
    onFilterClick, 
    onIgnoreOptimizations, 
    queryState 
}) => {
    const getCardConfigs = () => [
        {
            id: 'readiness',
            cardType: CARD_TYPES.UTILIZATION,
            parseResponse: parseReadinessResponse,
            values: readinessCardValues,
        },
        { id: 'cpu', cardType: CARD_TYPES.UTILIZATION, parseResponse: parseCPUResponse, values: cpuCardValues },
        { id: 'ram', cardType: CARD_TYPES.UTILIZATION, parseResponse: parseRAMResponse, values: ramCardValues },
        {
            id: 'storage',
            cardType: CARD_TYPES.UTILIZATION,
            parseResponse: parseStorageResponse,
            values: storageCardValues,
        },
    ];

    const cards = useMemo(
        () => buildCards(getCardConfigs(), { summaryData, totalInventory }, { onFilterClick, onIgnoreOptimizations }),
        [summaryData, totalInventory, onFilterClick, onIgnoreOptimizations],
    );

    return <SummaryCardRenderer cards={cards} isExpanded={isExpanded} queryState={queryState} />;
};
